import React from 'react';
import DocumentReader from './DocumentReader';
import { documentTitle, documentSlug, sections } from './content/iaa1940';

export default function InvestmentAdvisersAct() {
  return (
    <DocumentReader
      documentId={documentSlug}
      title={documentTitle}
      intro="The federal-law source for the Series 65 — registration, fiduciary duty, and antifraud provisions for investment advisers."
      parts={[{ id: 'iaa-full', title: null, sections }]}
    />
  );
}
